'use strict';

require('./index.less');


//////////////////
// WEBPACK FOOTER
// ./node_modules/antd-mobile/lib/icon/style/index.js
// module id = 176
// module chunks = 0